import * as Yup from 'yup';
import config from "../config";

export const adpClientId = (message?: string) => Yup.string().matches(config.regex.adpClientId, message || "Please enter a valid ADP Client ID")
